module.exports = __webpack_public_path__ + "static/media/loveseat.99a7bde9.svg";